export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center mb-24">
          <div className="order-2 lg:order-1">
            <div className="space-y-8">
              <div>
                <h2 className="text-5xl font-bold text-gray-900 mb-8 leading-tight">
                  Dedicated to{" "}
                  <span className="text-teal-600">Your Well-being</span>
                </h2>
                <p className="text-xl text-gray-600 leading-relaxed mb-6">
                  At Pamag Healthcare Services LLC, we believe that exceptional
                  care begins with understanding. Every individual has a unique
                  story, specific needs, and personal preferences that deserve
                  to be honored.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  Our approach combines professional expertise with genuine
                  compassion, creating care experiences that enhance quality of
                  life while preserving independence and dignity.
                </p>
              </div>

              <div className="bg-teal-50 rounded-2xl p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">
                  Our Promise
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  "We're not just caregivers – we're partners in your journey
                  toward health, happiness, and independence. Every service we
                  provide is tailored to your unique needs and delivered with
                  the respect and compassion you deserve."
                </p>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative">
            <div className="relative">
              <img
                src="/images/about/well-being.jpg"
                alt="Modern Care Environment"
                className="rounded-3xl shadow-2xl object-cover w-full h-[600px]"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Values section */}
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-6">
            What Drives Us
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Our core values shape every interaction and guide our commitment to
            exceptional care
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-3xl p-8 hover:shadow-lg transition-shadow duration-300">
            <h4 className="text-2xl font-bold text-gray-900 mb-4">
              Personalized Care
            </h4>
            <p className="text-lg text-gray-700 leading-relaxed">
              We recognize that no two individuals are alike. Our care plans are
              meticulously crafted to reflect personal preferences, health
              needs, and lifestyle choices, ensuring each person receives
              exactly the support they need.
            </p>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl p-8 hover:shadow-lg transition-shadow duration-300">
            <h4 className="text-2xl font-bold text-gray-900 mb-4">
              Family-Centered Approach
            </h4>
            <p className="text-lg text-gray-700 leading-relaxed">
              Families are integral to the care process. We work collaboratively
              with loved ones to ensure our services align with family values
              and expectations, creating a supportive network around each
              individual.
            </p>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-3xl p-8 hover:shadow-lg transition-shadow duration-300">
            <h4 className="text-2xl font-bold text-gray-900 mb-4">
              Professional Excellence
            </h4>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our team consists of highly trained, certified professionals who
              bring both expertise and empathy to their work. Continuous
              education and training ensures we deliver the highest standards of
              care.
            </p>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-3xl p-8 hover:shadow-lg transition-shadow duration-300">
            <h4 className="text-2xl font-bold text-gray-900 mb-4">
              Dignity & Independence
            </h4>
            <p className="text-lg text-gray-700 leading-relaxed">
              We believe in empowering individuals to maintain their
              independence while providing the support they need. Our services
              are designed to enhance capabilities rather than replace them.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
